import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.lg};
`
export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.md};
`

export const TextRow = styled.div`
  display: flex;
  flex-grow: 1;
  gap: ${theme.spacing.lg};
`

export const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.lg};
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.sm};
`

export const Form = styled.form`
  gap: 24px;
  .fileInput {
    margin-top: 24px;
  }

  .firstColumn {
    flex-basis: 100%;
    flex-shrink: 0;
  }

  .selectContainer {
    display: grid;
  }
  .secondColumn {
    flex-shrink: 0;
    flex-grow: 1;
  }

  .row {
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing.md};

    flex-wrap: wrap;
    .expand {
      @media (max-width: ${theme.breakpoints.lg}px) {
        flex-basis: 100%;
      }
    }
    .infoRow {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: ${theme.spacing.xm};
      .infoColumn {
        flex-direction: column;
        .info {
          svg {
            width: 17px;
          }
          span {
            vertical-align: 5px;
            margin-left: 6px;
          }
        }
      }
    }
    .infoRow2 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .infoColumn {
        flex-direction: column;
        .info {
          span {
            vertical-align: 5px;
            margin-left: 6px;
          }
        }
      }
    }
  }
  .no-gap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${theme.spacing.xm};
    @media (max-width: ${theme.breakpoints.lg}px) {
      gap: unset;
    }
  }
`

export const AlertDiv = styled.div`
  margin-bottom: ${theme.spacing.sm};
`
export const FormField = styled.div`
  display: grid;
  column-gap: 24px;

  .infoRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .infoColumn {
      flex-direction: column;
      .info {
        svg {
          width: 17px;
        }
        span {
          vertical-align: 5px;
          margin-left: 6px;
        }
      }
    }
  }
`
export const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${theme.spacing.lg};
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`
